import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesRoleCreateMain } from './modules/ui/Main';

const RoleCreatePage = (
  <SuspensePage>
    <PagesRoleCreateMain />
  </SuspensePage>
);

export default RoleCreatePage;
